import React, { useState, Fragment, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { Button, Grid, Typography } from '@mui/material';
import MyToolbar from '../../../../components/MyEditor/MyToolbar';
import MyEditor from '../../../../components/MyEditor/MyEditor';
import AlertPopUp from '../../../../components/AlertPopup';

const FullWidthStyle = {
  width: '100%'
};

const DefaultButtonStyle = {
  minHeight: 'unset',
  minWidth: 'unset',
  padding: '4px 8px',
  lineHeight: 1
};

const TextEditorInput = props => {
  const { intl, title, hint, value, onChange, onSetDefault } = props;

  const [warningDialog, setWarningDialog] = useState(false);
  const myEditorRef = useRef(null);
  const myToolbarRef = useRef(null);

  const openWarningDialog = () => setWarningDialog(true);
  const closeWarningDialog = () => setWarningDialog(false);
  const setDefault = () => {
    onSetDefault();
    closeWarningDialog();
  };

  return (
    <Fragment>
      <AlertPopUp
        intl={intl}
        open={warningDialog}
        handleClose={closeWarningDialog}
        handleUpdateUserProfile={setDefault}
        title={intl.formatMessage({ id: 'Confirm' })}
        description={intl.formatMessage({ id: 'adviser_message_delete' })}
        showUpdateButton={true}
      />
      <Grid container spacing={1} sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
        <Grid style={FullWidthStyle}>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Grid>
              <Typography className="field-label">{title}</Typography>
            </Grid>
            <Grid>
              <Button color="primary" variant="outlined" onClick={openWarningDialog} style={DefaultButtonStyle}>
                {intl.formatMessage({ id: 'Default' })}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {hint && (
          <Grid>
            <Typography
              sx={{
                display: 'inline'
              }}
            >
              {hint}
            </Typography>
          </Grid>
        )}
        <Grid style={FullWidthStyle}>
          <div className="my-editor-container">
            <MyToolbar
              textAlign={{ left: true, center: true }}
              editorState={value}
              onChange={onChange}
              ref={myToolbarRef}
              editorRef={myEditorRef}
            />
            <MyEditor
              editorState={value}
              onChange={onChange}
              textAlign={true}
              ref={myEditorRef}
              toolbarRef={myToolbarRef}
            />
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default injectIntl(TextEditorInput);
